var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusReportClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89062 7.90179L4.04597 6.74582C4.28518 6.50682 4.67279 6.50682 4.91201 6.74582L5.63244 7.46815C5.87166 7.70714 6.25927 7.70714 6.49848 7.46815L8.21669 5.75309C8.4559 5.51409 8.84351 5.51409 9.08272 5.75309L10.4007 7.07105C10.6399 7.31005 11.0275 7.31005 11.2667 7.07105L13.2906 5.06543",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9707 1V1.90638",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.90625C1 2.35396 1.44772 1.90625 2 1.90625H14.1818C14.7341 1.90625 15.1818 2.35397 15.1818 2.90625V10.8335C15.1818 11.3858 14.7341 11.8335 14.1818 11.8335H2C1.44771 11.8335 1 11.3858 1 10.8335V2.90625Z",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0918 11.8335V13.7244",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15039 15.18L8.09109 13.7246L10.0299 15.1787",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusReportClicked);
export default __webpack_public_path__ + "static/media/StatusReport_clicked.d6799b468a70cfa133db4ce8ecb91b8c.svg";
export { ForwardRef as ReactComponent };